














export default {
  name: 'spinning-cube'

  data: -> ready: false

  mounted: ->
    setTimeout @buildIn, 300

  methods: 
    buildIn: -> @ready = true
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SpinningCube.vue